@if ({
  speedRPMs: speedRPMs$ | async,
  outputHPs: outputHPs$ | async,
  voltages: voltages$ | async,
  frameSizes: frameSizes$ | async,
  outputKWs: outputKWs$ | async,
  mountings: mountings$ | async,
  phases: phases$ | async,
  enclosures: enclosures$ | async,
  }; as content) {
  <form class="m-t-20" [formGroup]="form" (submit)="submit()">
    <button type="button" class="btn btn-outline-danger btn-sm btn-clear" (click)="clear()">
      <span class="material-symbols-outlined d-flex"> delete_forever </span>
    </button>
    <div class="row">
      <div class="col-12">
        <p class="text-warning d-flex m-b-12">
          <span class="material-symbols-outlined d-flex m-r-4"> info </span>
          {{ 'advancedSearch.info' | cxTranslate }}
        </p>
      </div>
    </div>
    <div class="row first-line">
      <div class="col-12">
        <div class="form-group">
          <label>
            <span class="label-content">
              {{ 'advancedSearch.form.product_line.label' | cxTranslate }}
            </span>
            <input class="form-control" type="text" value="Motor" [disabled]="true" />
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div #speedRPM class="col-12 col-md-3">
        <amorph-select
          [form]="form"
          [controlName]="'speedRPM'"
          [label]="'advancedSearch.form.speed_rpm.label' | cxTranslate"
          [items]="content.speedRPMs || []"
          [type]="speedRPMInputType"
        ></amorph-select>
      </div>
      <div #outputHP class="col-12 col-md-3">
        @if (form.get('speedRPM')?.value !== '') {
          <amorph-select
            [form]="form"
            [controlName]="'outputHP'"
            [label]="'advancedSearch.form.output_hp.label' | cxTranslate"
            [items]="content.outputHPs || []"
            [type]="outputHPInputType"
          ></amorph-select>
        }
      </div>
      <div #voltage class="col-12 col-md-3">
        @if (form.get('outputHP')?.value !== '') {
          <amorph-select
            [form]="form"
            [controlName]="'voltage'"
            [label]="'advancedSearch.form.voltage.label' | cxTranslate"
            [items]="content.voltages || []"
            [type]="voltageInputType"
          ></amorph-select>
        }
      </div>
      <div class="col-12 col-md-3">
        @if (form.get('voltage')?.value !== '') {
          <amorph-select
            [form]="form"
            [controlName]="'frameSize'"
            [label]="'advancedSearch.form.frame_size.label' | cxTranslate"
            [items]="content.frameSizes || []"
            [type]="frameSizeInputType"
          ></amorph-select>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3">
        <amorph-select
          [form]="form"
          [controlName]="'outputKW'"
          [label]="'advancedSearch.form.output_kw.label' | cxTranslate"
          [items]="content.outputKWs || []"
        ></amorph-select>
      </div>
      <div class="col-12 col-md-3">
        <amorph-select
          [form]="form"
          [controlName]="'mounting'"
          [label]="'advancedSearch.form.mounting.label' | cxTranslate"
          [items]="content.mountings || []"
        ></amorph-select>
      </div>
      <div class="col-12 col-md-3">
        <amorph-select
          [form]="form"
          [controlName]="'phase'"
          [label]="'advancedSearch.form.phase.label' | cxTranslate"
          [items]="content.phases || []"
        ></amorph-select>
      </div>
      <div class="col-12 col-md-3">
        <amorph-select
          [form]="form"
          [controlName]="'enclosure'"
          [label]="'advancedSearch.form.enclosure.label' | cxTranslate"
          [items]="content.enclosures || []"
        ></amorph-select>
      </div>
      <div class="col-12 col-md-3">
        <div class="form-group">
          <label>
            <span class="label-content">
              {{ 'advancedSearch.form.application.label' | cxTranslate }}
            </span>
            <input class="form-control" type="text" name="application" maxlength="40" placeholder="..." formControlName="application" />
            <cx-form-errors [control]="form.get('application')"></cx-form-errors>
          </label>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="btn btn-primary">
        <span class="material-symbols-outlined d-flex m-r-4"> search </span>
        {{ 'advancedSearch.form.actions.search.label' | cxTranslate }}
      </button>
    </div>
  </form>
}
